import React, { useState } from "react";
import TextField from "../TextField/TextField";
import { InputFieldProps } from "../InputField/InputField";

const PasswordField = React.forwardRef<
  HTMLInputElement,
  Omit<InputFieldProps, "InputComponent">
>(({ ...props }, ref) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      {...props}
      ref={ref}
      type={showPassword ? "text" : "password"}
      addon={
        <button
          className="input-addon__wrapper"
          onClick={togglePassword}
          type="button"
        >
          {showPassword ? "verstecken" : "anzeigen"}
        </button>
      }
      data-testid="password-field"
    />
  );
});

export default PasswordField;
